import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { AuthStatus } from '../interfaces'
import { useAuthStore } from '../stores/auth.store'

const isNotAuthenticatedGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const authStore = useAuthStore()

  if (authStore.authStatus == AuthStatus.Checking) await authStore.checkAuthStatus()

  authStore.authStatus === AuthStatus.Authenticated ? next({ name: 'dashboard' }) : next()
}

export default isNotAuthenticatedGuard
